import styled from "styled-components";
import { scheduleApi } from "../../api/schedule-api";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { clearControlDeliveriesAction, clearDeliveryPageAction, clearDisplayDeliveriesAction, clearSelectedDisplayDeliveryIdAction, deliveryState } from "../../app/reducers/delivery-slice";
import { clearPreviewAction, clearUpdateScheduleAction, setPreviewAction } from "../../app/reducers/schedule-slice";
import theme from "../../style/theme";
import { DeliveryGroupType } from "../../types/schedule/delivery-group-type";
import useDidMountEffect from "../../utils/custom-hook/use-did-mount-effect";
import { DraggableControlDeliveriesItemList } from "../draggable-list/DraggableControlDeliveriesItemList";
import { queryClient } from "../..";
import { DeliveryQueryKey } from "../../query/delivery-query";

export const ControlDeliveryDrawer = () => {
    const dispatch = useAppDispatch();
    const { controlDeliveries } = useAppSelector(deliveryState);
    const filteredControlDeliveries = controlDeliveries.filter(
        (controlDelivery) => controlDelivery.type !== DeliveryGroupType.Split
    );

    const getPreview = async () => {
        const nonSplitDeliveries = controlDeliveries.filter(delivery => delivery.type !== DeliveryGroupType.SPLIT);
        if (nonSplitDeliveries.length === 0) {
            dispatch(setPreviewAction({
                previewDto: {
                    deliverySegments: [],
                    deliveryGroups: [],
                }
            }));
            return;
        }

        try {
            const payload = controlDeliveries.map((controlDelivery) => {
                return {
                    id: controlDelivery.delivery.id,
                    type: controlDelivery.type,
                };
            });

            const response = await scheduleApi.preview({ deliverySegments: payload });
            dispatch(setPreviewAction({ previewDto: response.data }));
        } catch (error) {
            console.log(error);
        }
    };

    useDidMountEffect(() => {
        getPreview();
    }, [controlDeliveries]);

    return (
        <Container>
            <Header>
                <HeaderLabel>전체 물류 목록</HeaderLabel>
            </Header>
            {filteredControlDeliveries.length > 0 && (
                <ContentContainer>
                    <DraggableControlDeliveriesItemList />
                </ContentContainer>
            )}
        </Container>
    );
};

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  z-index: 99999;
  background: ${theme.palette.primitives.white};
  flex: 1;
  overflow-y: scroll;

  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const Header = styled.div`
  padding: 20px 24px;
  border-top: 1px solid ${theme.palette.primitives.gray200};
  border-bottom: 1px solid ${theme.palette.primitives.gray200};
`;

const HeaderLabel = styled.div`
  font-weight: 500;
  font-size: 18px;
  color: ${theme.palette.primitives.gray800};
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
`;
